"use strict";

(function ($) {

    // TODO Youtube Iframe
    $('.youtubeiFrame').on('click', function () {
      if($(this).data('iframeurl')){
        $(this).find('img').remove();
        $(this).append('<iframe src="' + $(this).data('iframeurl') + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%;height: 300px;"> </iframe>');
      }
    });

    // TODO FAQ Sorting Functionality
    $('#filters a').on('click', function(e){
        e.preventDefault();
        let term = $(this).data('filter');
        $(this).addClass('faq-filter-active').siblings().removeClass('faq-filter-active');
        if(term === 'all') {
            $('#items li').css('display', 'inline-block');
        } else {
            $('#items li').hide();
            $('#items li[data-filter-item="'+term+'"]').css('display', 'inline-block');;
        }
    });

    // TODO Redirect Thanks Page
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        window.location.href = '/thank-you/';
    }, false);
  
    // TODO Scroll To ID
    $(document).on('click', 'a[href^=\\#]', function(e){
        let el = $($(this).attr('href'));
        if(el.length && el.offset()) { // one of those may be unnecessary
            e.preventDefault();
        $('html, body').animate({
            scrollTop: el.offset().top - $('header').height()
           }, 2000);
        }
    });

    // TODO Menu mobile
    $('button.burger').on('click', function () {
        $('body').toggleClass('overflowGlobal');
        $('.header-nav').toggleClass('active');
        $(this).toggleClass('burger-active');
    });

    // TODO Add functionality for the mobile menu open
    $('.header .genesis-nav-menu > ul > .menu-item-has-children').on('click', function () {
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    $('.header .genesis-nav-menu > ul > .menu-item-has-children .menu-item-has-children').on('click', function (event) {
        event.stopPropagation();
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    // TODO Header active class, CTA on mobile and btn up fixed elements
    let lastScrollTop = 0;
    function menuFixed() {
        // Header Active Class
        if ($(window).scrollTop() > 20) {
            $('.header').addClass('header-active');
        } else {
            $('.header').removeClass('header-active');
        }
        // CTA on mobile show/hide
        let st = $(this).scrollTop();
        let header = $('header.header');
        if(header.hasClass('header-mobile')) {
            if($(window).scrollTop() > 350) {
                if (st >= lastScrollTop){
                    header.addClass('header-scroll');
                } else {
                    header.removeClass('header-scroll')
                }
            }
            lastScrollTop = st;
        }
        // Btn Up Active Show/Hide
        if ($(this).scrollTop() > 500) {
            $('#scrollToTop').addClass('btn-up-active');
        } else {
            $('#scrollToTop').removeClass('btn-up-active');
        }
    }

    $(window).bind('scroll', menuFixed);

    // TODO scroll body to 0px on click
    $('#scrollToTop').on('click', function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, 700);
        $(this).removeClass('btn-up-active');
    });

    // TODO HD Modal
    $('.open-hd-modal').click(function () {
        var hdModalTitle = $(this).data('hd-modal-title');
        var hdModalContentType = $(this).data('hd-modal-content-type');
        var hdModalContent = $(this).data('hd-modal-content');
        var hdModalHTML = '<div class="hd-modal">';

        hdModalHTML += '<div class="hd-modal-top">';
        if (hdModalTitle) {
            hdModalHTML += '<span class="hd-modal-title">' + hdModalTitle + '</span>';
        }
        hdModalHTML += '<div class="hd-modal-close">' + '<svg clip-rule="evenodd" width="24" height="24" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg></div></div>';

        if (hdModalContentType === 'youtube') {
            hdModalHTML = hdModalHTML + '<div class="hd-modal-before"><iframe src="https://www.youtube.com/embed/' + hdModalContent + '?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
        } else if (hdModalContentType === 'wistia') {
            hdModalHTML += `<div class="hd-modal-before"><iframe src="https://fast.wistia.net/embed/iframe/${hdModalContent}" allowfullscreen frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allow="autoplay; fullscreen" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"></iframe></div><script src="https://fast.wistia.com/embed/medias/${hdModalContent}.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>`;
        } else {
            hdModalHTML = hdModalHTML + hdModalContent;
        }

        $('#hd-modal-container').append(hdModalHTML);
        $('#hd-modal-container').fadeIn();
    });
    $(document).on('click', '.hd-modal-close , #hd-modal-container', function (e) {
        /*
        * The First Statement checks if the user is clicking outside of the modal
        * The Second Statement checks if the user clicked the X button
        * Meaning this if is: If User clicked outside of the modal OR clicked on the X button, destroy the modal
        * */
        if(($(this).is('#hd-modal-container') && !$(e.target).closest('.hd-modal').length) || $(this).hasClass('hd-modal-close')){
            $('#hd-modal-container').fadeOut(function () {
                $(this).empty();
            });
        }
    });

    // TODO Table of content
    $(".blogSidebar .contents").on("click", function () {
        $(this).toggleClass("active");
        $('.contents-wrap').slideToggle(500);
        if ($(this).hasClass("active")) {
            $(".js-fix").text("Close");
        } else {
            $(".js-fix").text("Expand");
        }
    });

    // TODO Results page tabs

    // TODO Results page tabs
    $('.page-results-tab').on('click', function () {
        var target = $(this).data('tab');

        $('.page-results-tab').removeClass('is-active').attr('aria-selected', 'false');
        $('.page-results-panel').removeClass('is-active');

        $(this).addClass('is-active').attr('aria-selected', 'true');
        $('.page-results-panel[data-panel="' + target + '"]').addClass('is-active');
    });

})(jQuery);

// TODO Scroll-triggered animations
(function () {
    var transforms = {
        'anim-fade-up':    'translateY(40px)',
        'anim-fade-top':   'translateY(-40px)',
        'anim-fade-left':  'translateX(60px)',
        'anim-fade-right': 'translateX(-60px)'
    };
    var SEL = '.anim-fade-up, .anim-fade-top, .anim-fade-left, .anim-fade-right';

    function reveal() {
        var winH = window.innerHeight;
        var pending = document.querySelectorAll(SEL + ':not(.is-animated)');
        for (var i = 0; i < pending.length; i++) {
            if (pending[i].getBoundingClientRect().top < winH - 60) {
                pending[i].classList.add('is-animated');
            }
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        var isMobile = window.innerWidth <= 992;
        var activeTransforms = isMobile ? {
            'anim-fade-up':    'translateY(40px)',
            'anim-fade-top':   'translateY(-40px)',
            'anim-fade-left':  'translateY(20px)',
            'anim-fade-right': 'translateY(20px)'
        } : transforms;

        // Set initial hidden state via inline style (JS-only, no CSS opacity conflict)
        var all = document.querySelectorAll(SEL);
        for (var i = 0; i < all.length; i++) {
            var el = all[i];
            var t = '';
            for (var cls in activeTransforms) {
                if (el.classList.contains(cls)) { t = activeTransforms[cls]; break; }
            }
            el.style.opacity = '0';
            el.style.transform = t;
        }
        // Reveal anything already in view
        reveal();
    });

    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal, { passive: true });
}());